<div class="card rounded-0">
  <div class="card-header border-0 m-auto">
    <span class="card-title m-0">{{headerTitle}}</span>
    <button type="button" class="close" (click)="bsModalRef.hide()">
      <span><i class="icon icon-btn-close" aria-hidden="true"></i></span>
    </button>
  </div>

  <ng-content select=".content"></ng-content>

  <div class="card-footer border-0 m-auto">
    <div class="controls">
      <button type="button" class="btn border-0 gray mr-2" (click)="bsModalRef.hide()">
        <span>CANCEL</span>
      </button>
      <button type="button" class="btn border-0 blue" [disabled]='!allowSubmit' (click)="onSubmit()">
        <span>{{buttonTitle | uppercase}}</span>
      </button>
    </div>
  </div>
</div>
